module.exports = __webpack_public_path__ + "img/blockchain.dc0b003a.png";